import Vue from 'vue';
import Vuex from 'vuex';
import router from './../router';

Vue.use(Vuex);

const API_URL = 'https://toolie.se/helpie' //'http://localhost:3000';

export default new Vuex.Store({
  state: {
    showRoomOverlay: false,
    showInfo: false,
    students: {},
    errorMsg: 'Let It Be',
    studentState: {},
    publicHelpBoard: {},
    owner: ''
  },
  mutations: {
    toggleRoomOverlay(state){
      state.showRoomOverlay = !state.showRoomOverlay;
    },
    toggleInfo(state){
      state.showInfo = !state.showInfo;
    },
    setStudents(state, students) {
      state.students = students;
    },
    setErrorMsg(state, msg){
      state.errorMsg = msg;
    },
    setStudentState(state, studentState){
      state.studentState = studentState;
    },
    setPublicHelpBoard(state, publicHelpBoard) {
      state.publicHelpBoard = publicHelpBoard;
    },
    setOwner(state, ownerId) {
      state.owner = ownerId;
    },
    updateStudentToken(state, token) {
      state.studentState.token = token;
    }
  },
  actions: {
    async createRoom({ dispatch, commit }) {
      try {
        const response = await fetch(`${API_URL}/rooms`, { method: 'POST'});
        const data = await response.json();

        commit('setOwner', data.room.owner);
        await dispatch('saveToken', data.room.owner);

        router.push(`/${data.room.id}/teacher`);

      } catch(error) {
        console.error(error);
      }
    },
    async getRoom({ commit }, room) {
      try {
        const response = await fetch(`${API_URL}/rooms/${room}`);
        const data = await response.json();
        console.log(data);
        commit('setStudents', data.room);
        commit('setOwner', data.room.owner);
      } catch(error) {
        console.error(error);
      }
    },
    async joinRoom(ctx, student) {
      try {
        const roomExists = await ctx.dispatch('checkRoomExists', student.room);

        if (!roomExists) {
          ctx.commit('setErrorMsg', 'The room you entered does not exist.');
          router.push('/error')
        } else {
          const token = localStorage.getItem('auth');
          const response = await fetch(`${API_URL}/rooms/${student.room}/join`, {
            method: 'POST',
            body: JSON.stringify({ name: student.name, public: student.public }),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });
          const data = await response.json();
          await ctx.dispatch('saveToken', data.token);

          router.push(`/${student.room}/student`);
        }
  
      } catch(error) {
        console.error(error);
      }
    },
    async checkRoomExists(ctx, room) {
      try {
        const response = await fetch(`${API_URL}/rooms/${room}/exists`);
        const data = await response.json();
        
        return data.success;
      } catch(error) {
        console.error(error);
      }
    },
    async getStatus({ commit }, room) {
      try {
        const token = localStorage.getItem('auth');
        const response = await fetch(`${API_URL}/rooms/${room}/status`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        
        if(!data.status){
          router.push(`/${room}/student/2`).catch(()=>{});
        } else {
          commit('setStudentState', data);
          router.push(`/${room}/student/${data.status}`).catch(()=>{});
        }
      } catch(error) {
        console.error(error);
      }
    },
    async saveToken(ctx, token) {
      return new Promise((resolve) => {
        localStorage.setItem('auth', token);
    
        resolve('Done');
      });
    },
    async updateStatus({ dispatch }, newStatus) {
      try {
        const token = localStorage.getItem('auth');
        const response = await fetch(`${API_URL}/rooms/${newStatus.room}/status/${newStatus.status}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        console.log(data);
        
        dispatch('getStatus', newStatus.room);
      } catch(error) {
        console.error(error);
      }
    },
    async helped(ctx, studentHelped) {
      const response = await fetch(`${API_URL}/rooms/${studentHelped.room}/status/2`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${studentHelped.student}`,
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      console.log(data);
    },
    async logout({ commit }, room) {
      try {
        const token = localStorage.getItem('auth');
        const response = await fetch(`${API_URL}/rooms/${room}/logout`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        console.log(data);

        commit('setStudentState', {});

        router.push('/').catch(()=>{});
      } catch (error) {
        console.error(error);
      }
    },
    async getHelpBoard({ commit }, room) {
      try {
        const token = localStorage.getItem('auth');
        const response = await fetch(`${API_URL}/rooms/${room}/public`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        console.log(data);
        
        commit('setPublicHelpBoard', data);
      } catch(error) {
        console.error(error);
      }
    }
  },
  getters: {
    help(state){
      return state.students.help;
    },
    ongoing(state){
      return state.students.ongoing;
    },
    done(state){
      return state.students.done;
    },
    student(state) {
      return state.studentState.student;
    },
    owner(state) {
      return state.owner;
    }
  }
})
